module.exports = __webpack_public_path__ + "static/media/pendingIcon.487ce3ca.png";